export default __webpack_public_path__ + "static/media/3.453d4cbb.png";